import React from "react";
import { Row, Col } from 'antd';
import { Spinner } from "@public/ui-toolkit";

const VideoModal = ({ myFundDetails, onCreateAuditLogs,mediaLoading = false, portal = "allocator" }) => {
  const playVideo = () => {
    var video = document.getElementById('video');
    
    video.addEventListener("pause", (event) => {
      getCurrentDuration(event.target.currentTime)
    });
  };
  const getCurrentDuration = (values) => {
    const obj = {
      actionName: "Watch Video",
      parameters: { WatchTime: `${values.toFixed(2)} sec` }
    }
    onCreateAuditLogs(obj);
  }
  return (
    <>
    {!mediaLoading ? (
      <>
      {myFundDetails?.record?.length ? (
        <Row className= {portal === "allocator" ? "flex-nowrap  scrollbar" : ""}>
          {myFundDetails?.record?.map(({ url, type, thumbnail }, index) => (
            <Col span={8}   
              style={{ padding : "10px" }}           
              data-bs-toggle={"modal"}
              data-bs-target={`#video-pop${index}`}
              key={url}
            >
              <div onClick={type?.toLowerCase() === "video" ? playVideo : ""}>
                <div className="media-thumbnail-box" style={{ height : "220px" }}>
                  {type?.toLowerCase() === "video" || type === null ? (
                    <video
                      className="media-thumbnail"
                      alt="media thumbnail"
                      poster={thumbnail}
                    >
                      <source src={url} />
                    </video>
                  ) : (
                    <img
                      src={url}
                      className="media-thumbnail"
                      alt="media thumbnail"
                    />
                  )}
                  {(type?.toLowerCase() === "video" || type === null) && (
                    <img
                      src="/assets/images/video-icon.svg"
                      style={{ filter : "drop-shadow(5px 5px 5px #222)" }}
                      className="media-icon"
                      alt="play icon"
                    />
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        <Row style={{ margin: "100px 20px" }} className="row flex-row flex-nowrap " >
          <Col span={24}
            className="alert alert-primary text-center w-75 d-flex m-auto justify-content-center"
            role="alert"
          >
            Production in process!
          </Col>
        </Row>
      )}
      </>
      ) : (
        <Row className="text-center">
          <Col span={24}>
            <Spinner />
          </Col>
        </Row>
      )}
    </>
  );
};

export default VideoModal;
